import React, { useEffect, useState } from 'react';
import ParentDocCard from '../../common/ParentDocCard';
import { DateFormat } from './DateFormat/DateFormat';
import CustomDomains from './DateFormat/CustomDomains/CustomDomains';
import { RefreshProject } from './RefreshProject/RefreshProject';
import ImportProject from '../environments/ImportProject';

export const AppConfigTab = ({
  projectId,
  version,
  dateFormat,
  updateDateFormat,
  toggle,
  actions,
}) => {
  const [projectData, setProjectData] = useState({});
  useEffect(() => {
    const getData = async () => {
      const response = await actions.fetchProject({ projectId });
      const { data } = response;
      setProjectData(data);
    };
    getData();
  }, []);
  return (
    <>
      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
        <RefreshProject projectId={projectId} version={version} actions={actions} />
        <DateFormat
          projectId={projectId}
          version={version}
          dateFormat={dateFormat}
          updateDateFormat={updateDateFormat}
        />
        <CustomDomains
          projectDetail={projectData}
          actions={actions}
          projectId={projectId}
          version={version}
        />
        <ImportProject
          projectDetail={projectData}
          actions={actions}
          projectId={projectId}
          version={version}
        />
      </div>
      <ParentDocCard>
        <h5>
          <b>About App Setting Date Format</b>
        </h5>
        <p>DrapCode supports multiple format for date you can choose according to you</p>
        <br />
      </ParentDocCard>
    </>
  );
};
